const darkColors = {
  surface: {
    100: "#F9FAFB",
    200: "#E5E7EB",
    300: "#CBD5E1",
    400: "#94A3B8",
    500: "#64748B",
    600: "#334155",
    700: "#1E293B",
    800: "#111827",
    900: "#070B14",
  },

  // Brand / magenta accent
  primary: {
    100: "#FFE4EC",
    200: "#FFB8CD",
    300: "#FF7FA7",
    400: "#F43F75",
    500: "#E40046",
    600: "#C2003B",
    700: "#99002F",
    800: "#66001F",
    900: "#330010",
  },

  // Atmospheric blue
  secondary: {
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#2563EB",
    600: "#1D4ED8",
    700: "#1E40AF",
    800: "#172554",
    900: "#0B1120",
  },

  // Scientific cyan
  info: {
    100: "#D9F8FF",
    200: "#A5F3FC",
    300: "#67E8F9",
    400: "#22D3EE",
    500: "#00B4D8",
    600: "#0891B2",
    700: "#0E7490",
    800: "#155E75",
    900: "#083344",
  },

  // Modern teal success
  success: {
    100: "#D1FAE5",
    200: "#A7F3D0",
    300: "#6EE7B7",
    400: "#34D399",
    500: "#10B981",
    600: "#059669",
    700: "#047857",
    800: "#065F46",
    900: "#064E3B",
  },


  banner: {
    dark: "#040810",   // deep navy
    main: "#070d1c",   // charcoal navy
    light: "#1E293B",  // lighter slate navy
  },
};

const lightColors = {
  surface: {
    100: "#0B1220",
    200: "#111827",
    300: "#1F2937",
    400: "#374151",
    500: "#6B7280",
    600: "#9CA3AF",
    700: "#D1D5DB",
    800: "#E5E7EB",
    900: "#F4F6F8",
  },

  // Brand / magenta accent
  primary: {
    100: "#330010",
    200: "#66001F",
    300: "#99002F",
    400: "#C2003B",
    500: "#E40046",
    600: "#F43F75",
    700: "#FF7FA7",
    800: "#FFB8CD",
    900: "#FFE4EC",
  },

  // Atmospheric blue
  secondary: {
    100: "#0B1120",
    200: "#172554",
    300: "#1E3A8A",
    400: "#1D4ED8",
    500: "#2563EB",
    600: "#3B82F6",
    700: "#93C5FD",
    800: "#BFDBFE",
    900: "#DBEAFE",
  },

  // Scientific cyan
  info: {
    100: "#083344",
    200: "#155E75",
    300: "#0E7490",
    400: "#0891B2",
    500: "#00B4D8",
    600: "#22D3EE",
    700: "#67E8F9",
    800: "#A5F3FC",
    900: "#D9F8FF",
  },

  // Modern teal success
  success: {
    100: "#064E3B",
    200: "#065F46",
    300: "#047857",
    400: "#059669",
    500: "#10B981",
    600: "#34D399",
    700: "#6EE7B7",
    800: "#A7F3D0",
    900: "#D1FAE5",
  },

  banner: {
    dark: "#0B1220",   // deep navy
    main: "#111827",   // charcoal navy
    light: "#1E293B",  // lighter slate navy
  }  
};

export const colorTokens = (mode: string) => ({
  ...(mode === 'dark' ? darkColors : lightColors)
});